export default {
  vipUpgrade: {
    title: 'ยินดีด้วย!!',
    message: 'คุณได้อัปเกรดจาก VIP{from} เป็น VIP{to}',
    subtitle: 'ขอบคุณสำหรับการสนับสนุน ระดับใหม่ของคุณมาพร้อม\nบริการพิเศษและสิทธิพิเศษ',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
